import { FunctionComponent, memo, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { trackUser } from "utilities/track-user";
import { getPageName } from "utilities/get-page-name";

import { IProps } from "./track-page-changes.types";
import "./track-page-changes.scss";

/**
 * Record when a user navigates to other pages for analytics purposes.
 * @returns Empty render.
 */
const TrackPageChanges: FunctionComponent<IProps> = () => {
    const location = useLocation();

    // Listen for page changes.
    useEffect(() => {
        const pageName = getPageName(location.pathname);
        if (typeof pageName !== "undefined") {
            trackUser("Page Load", { pageName }, true);
        }
    }, [location.pathname]);

    return null;
};

export default memo(TrackPageChanges);
